
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../../grpc"

import {
    Timestamp,
} from "../../../google/protobuf/timestamp"

import {
    EnumValue,
} from "../../../google/protobuf/type"

import {
    Empty,
} from "../../../google/protobuf/empty"

/* client取值: scannerv2.app, scannerv2.store, scannerv2.institution */
export interface LoginByMobileNumberAndPasswordRequest {
    countryCode: string
    mobileNumber: string /* 手机号 */
    password: string
    client: string
}

export interface LoginByEmailAndPasswordRequest {
    email: string /* 邮箱 */
    password: string
    client: string
}

export interface LoginResponse {
    accountId: number
    activated: boolean
    expireTime: Timestamp
    accessToken: string
    refreshToken: string /* 刷新的token，有效期30天 */
}

export interface LoginByMobileNumberAndCaptchaRequest {
    countryCode: string
    mobileNumber: string
    captcha: string
    client: string
}

export interface SendCaptchaRequest {
    countryCode: string
    mobileNumber: string
    templateType: EnumValue /* 通过ListSmsTemplateTypes接口获取 */
}

export interface ListSmsTemplateTypesRequest {
}

export interface ListSmsTemplateTypesResponse {
    templateTypes: Array<EnumValue>
}

export interface ResetPasswordRequest {
    /*int64 account_id = 1; */
    oldPassword: string
    newPassword: string
}

export interface RefreshTokenRequest {
    refreshToken: string
}

export interface RefreshTokenResponse {
    accessToken: string
    expireTime: Timestamp
    refreshToken: string /* 刷新的token，有效期30天 */
}

export interface Account {
    role: string
    id: number
    name: string
    mobileNumber?: string
    email?: string
}

export interface CreateAccountRequest {
    organizationId: number /* 具体可为institution_id或store_id */
    role: string /* superAdmin, admin, staff */
    name: string /* 昵称 */
    countryCode?: string /* 默认值86 */
    mobileNumber?: string /* 手机号码 */
    email?: string /* 邮箱 */
}

export interface UpdateAccountRequest {
    organizationId: number /* 具体可为institution_id或store_id */
    accountId: number
    name: string /* 昵称 */
    role: string
    countryCode?: string /* 默认值86 */
    mobileNumber?: string /* 手机号码 */
    email?: string /* 邮箱 */
}

export interface DeleteAccountRequest {
    organizationId: number
    accountId: number
}

export interface ListAccountsRequest {
    organizationId: number
}

export interface ListAccountsResponse {
    accounts: Array<Account>
}

export interface BatchGetAccountsRequest {
    organizationIds: Array<number>
}

export interface BatchGetAccountsResponse {
    accountInfos: Array<AccountInfo>
}

export interface AccountInfo {
    organizationId: number
    account: Account
}

export class AccountService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /* 密码登录 */
    async loginByMobileNumberAndPassword(request: LoginByMobileNumberAndPasswordRequest): Promise<LoginResponse> {
        const method = "post"
        const path = "/scanner.v2.AccountService/LoginByMobileNumberAndPassword"
        return await this.call(method, path, request) as LoginResponse
    }
    
    /* 验证码登录 */
    async loginByMobileNumberAndCaptcha(request: LoginByMobileNumberAndCaptchaRequest): Promise<LoginResponse> {
        const method = "post"
        const path = "/scanner.v2.AccountService/LoginByMobileNumberAndCaptcha"
        return await this.call(method, path, request) as LoginResponse
    }
    
    /* 邮箱登录 */
    async loginByEmailAndPassword(request: LoginByEmailAndPasswordRequest): Promise<LoginResponse> {
        const method = "post"
        const path = "/scanner.v2.AccountService/LoginByEmailAndPassword"
        return await this.call(method, path, request) as LoginResponse
    }
    
    /* 发送验证码 */
    async sendCaptcha(request: SendCaptchaRequest): Promise<Empty> {
        const method = "post"
        const path = "/scanner.v2.AccountService/SendCaptcha"
        return await this.call(method, path, request) as Empty
    }
    
    /* 获取短信模板类型 */
    async listSmsTemplateTypes(request: ListSmsTemplateTypesRequest): Promise<ListSmsTemplateTypesResponse> {
        const method = "post"
        const path = "/scanner.v2.AccountService/ListSmsTemplateTypes"
        return await this.call(method, path, request) as ListSmsTemplateTypesResponse
    }
    
    /* 重置密码 */
    async resetPassword(request: ResetPasswordRequest): Promise<Empty> {
        const method = "post"
        const path = "/scanner.v2.AccountService/ResetPassword"
        return await this.call(method, path, request) as Empty
    }
    
    /* 刷新token */
    async refreshToken(request: RefreshTokenRequest): Promise<RefreshTokenResponse> {
        const method = "post"
        const path = "/scanner.v2.AccountService/RefreshToken"
        return await this.call(method, path, request) as RefreshTokenResponse
    }
    
    /* 创建账号，不需要一次性创建三个（superAdmin、admin、staff） */
    async createAccount(request: CreateAccountRequest): Promise<Account> {
        const method = "post"
        const path = "/scanner.v2.AccountService/CreateAccount"
        return await this.call(method, path, request) as Account
    }
    
    /* 更新管理员账号信息 */
    async updateAccount(request: UpdateAccountRequest): Promise<Account> {
        const method = "post"
        const path = "/scanner.v2.AccountService/UpdateAccount"
        return await this.call(method, path, request) as Account
    }
    
    /* 删除组织下的管理员 */
    async deleteAccount(request: DeleteAccountRequest): Promise<Empty> {
        const method = "post"
        const path = "/scanner.v2.AccountService/DeleteAccount"
        return await this.call(method, path, request) as Empty
    }
    
    /* 获取组织下的管理账号 */
    async listAccounts(request: ListAccountsRequest): Promise<ListAccountsResponse> {
        const method = "post"
        const path = "/scanner.v2.AccountService/ListAccounts"
        return await this.call(method, path, request) as ListAccountsResponse
    }
    
    /* 批量获取原始管理员账号 */
    async batchGetAccounts(request: BatchGetAccountsRequest): Promise<BatchGetAccountsResponse> {
        const method = "post"
        const path = "/scanner.v2.AccountService/BatchGetAccounts"
        return await this.call(method, path, request) as BatchGetAccountsResponse
    }
    
}
